// Ableitung der Fiori-Top-Navigation aus der bestehenden Sidebar-Konfiguration.
// RBAC-/ENV-/Menue-Filter sind 1:1 wie in SidebarNav — KEIN Menuepunkt geht verloren.
import getNavSections from '../sidebar/sidebarNavConfig';

// Gruppierung: 8 Sidebar-Sektionen -> 6 Fiori-Top-Gruppen (Audit §3 Nav-Mapping)
export const TOP_GROUPS = [
  { id: 'mein_bereich', sectionIds: ['overview'], home: '/home' },
  { id: 'reklamationen', sectionIds: ['complaints'] },
  { id: 'lieferanten', sectionIds: ['supplier'] },
  { id: 'auswertung', sectionIds: ['analytics'] },
  { id: 'sap', sectionIds: ['sap_admin'] },
  { id: 'system', sectionIds: ['organisation', 'kataloge', 'system'] },
];

export const groupLabels = (t) => ({
  mein_bereich: t('fiori.nav.myArea', 'Mein Bereich'),
  reklamationen: t('fiori.nav.complaints', 'Reklamationen'),
  lieferanten: t('fiori.nav.suppliers', 'Lieferanten'),
  auswertung: t('fiori.nav.analytics', 'Auswertung'),
  sap: 'SAP',
  system: t('fiori.nav.system', 'System'),
});

// Untertitel je Top-Gruppe fuer das Modul-Panel (SAP-Fiori-Klick-Navigation)
export const groupSubtitles = (t) => ({
  mein_bereich: t('fiori.nav.sub.myArea', 'Persönliche Übersicht und aktuelle Aufgaben'),
  reklamationen: t('fiori.nav.sub.complaints', 'Q-/Q3 Reklamationen verwalten'),
  lieferanten: t('fiori.nav.sub.suppliers', 'Q2-Reklamationen und Lieferantenqualität'),
  auswertung: t('fiori.nav.sub.analytics', 'Berichte, KPIs und Analysen'),
  sap: t('fiori.nav.sub.sap', 'Suche, Stammdaten und SAP-nahe Funktionen'),
  system: t('fiori.nav.sub.system', 'Administration und Konfiguration'),
});

// Kurzbeschreibungen je Menuepunkt (sprachunabhaengiger menuKey -> DE-Text).
// Optional: fehlt ein Eintrag, zeigt die Kachel nur den Titel.
export const ITEM_DESCRIPTIONS = {
  neue_reklamation: 'Neue Reklamation erfassen',
  sap_suche: 'SAP-Daten & Stammdaten suchen',
  alle_reklamationen: 'Bestehende Fälle suchen & öffnen',
  sap_drafts: 'E-Mail-Drafts manuell bestätigen',
  meine_aufgaben: 'Persönliche offene Aufgaben',
  maßnahmen_tracking: 'Maßnahmen verfolgen',
  cost_postings: 'Kosten erfassen & freigeben',
  email_eingang: 'Eingehende E-Mails verwalten',
  lieferantenreklamationen: 'Q2-Reklamationen verwalten',
  neue_q2_meldung: 'Neue Q2-Meldung erfassen',
  lieferanten_stammdaten: 'Lieferanten-Stammdaten pflegen',
  analytics_dashboard: 'Berichte & KPIs',
  pareto_analysis: 'Ursachen nach Pareto-Prinzip',
  benutzerverwaltung: 'Benutzer verwalten',
  rollenverwaltung: 'Rollen & Berechtigungen',
  entra_gruppen_mapping: 'Entra-Gruppen zuordnen',
  entra_id_status: 'Entra-ID-Status abfragen',
  identity_invitations: 'Einladungen & Freigaben',
  werksorganisation: 'Werks-/Plant-Struktur',
  zqm_organisation: 'QM-Entscheidungsmatrix',
  verkaufsorganisation: 'SAP-Vertriebsstruktur',
  sap_tenant_verwaltung: 'SAP-Tenants verwalten',
  sap_stammdaten: 'SAP-Stammdaten',
  field_mapping: 'Feld-Zuordnungen',
  webhook_status: 'Webhook-Ereignisse',
  sap_outbox: 'Ausgehende SAP-Nachrichten',
  scim_audit: 'SCIM-Audit-Log',
  scim_tokens: 'SCIM-Tokens verwalten',
  dlq_inbox: 'Fehlerwarteschlange (DLQ)',
  system_status: 'Systemstatus & Secrets',
  katalogverwaltung: 'Kataloge pflegen',
  email_log: 'E-Mail-Protokoll',
  intake_ledger: 'Eingangsüberwachung & SAP-Drafts (kombiniert)',
  audit_log: 'Änderungsprotokoll',
  ki_quality_gate: 'KI-Quality-Gate',
  ki_konfiguration: 'KI-Einstellungen',
  erscheinungsbild: 'Design & Theme',
  dokumentation: 'Handbuch & Übergabe',
  system_reset: 'Daten zurücksetzen',
};

// Sichtbarkeits-Filter (identisch zu SidebarNav)
export function isItemVisible(item, user) {
  if (item.permission && !user?.permissions?.[item.permission]) {
    if (!item.permissionAlt || !user?.permissions?.[item.permissionAlt]) return false;
  }
  if (item.requiresEnv && !process.env[item.requiresEnv]) return false;
  const menuItems = user?.permissions?.visible_menu_items;
  if (menuItems && menuItems.length > 0 && item.menuKey) {
    return menuItems.includes(item.menuKey);
  }
  return true;
}

// Baut die sichtbaren Top-Gruppen inkl. gefilterter Items
export function buildGroups(t, user) {
  const sections = getNavSections(t);
  const byId = Object.fromEntries(sections.map((s) => [s.id, s]));
  const labels = groupLabels(t);
  return TOP_GROUPS.map((g) => {
    const items = g.sectionIds.flatMap((sid) =>
      (byId[sid]?.items || []).filter((it) => isItemVisible(it, user))
    );
    return { id: g.id, label: labels[g.id], home: g.home, items };
  }).filter((g) => g.home || g.items.length > 0);
}

// Aktiv-Erkennung (analog Sidebar.isActive)
export function isPathActive(path, location) {
  if (path === '/home') return location.pathname === '/home';
  if (path.includes('?')) {
    const [basePath, query] = path.split('?');
    if (!location.pathname.startsWith(basePath)) return false;
    return location.search.includes(query);
  }
  if (path === '/catalog-management' && location.search.includes('tab=sales')) return false;
  return location.pathname.startsWith(path);
}
